import createPubSub from "@lazarentertainment/js-pubsub";
export function createStatefulPubSub(initialState, pubSub = createPubSub()) {
    const state = Object.assign({}, initialState);
    const set = (key, ...args) => {
        const currentValue = state[key];
        const [newValue] = args;
        state[key] = newValue;
        if (newValue !== currentValue) {
            pubSub.publish(key, ...args);
        }
    };
    const get = (key) => state[key];
    const methods = (key) => [
        () => get(key),
        (...args) => set(key, ...args),
    ];
    return {
        pubSub,
        get,
        set,
        methods,
    };
}
